customElements.define("map-marker", class extends HTMLElement {

    static get observedAttributes() { return ["latitude", "longitude"] }

    get latitude() { return parseFloat(this.getAttribute("latitude")) }
    get longitude() { return parseFloat(this.getAttribute("longitude")) }
    get src() { return this.getAttribute("src") }
    get width() { return this.getAttribute("width") }
    get height() { return this.getAttribute("height") }
    get cx() { return this.getAttribute("cx") }
    get cy() { return this.getAttribute("cy") }
    get slot() { return this.getAttribute("slot") }
    get external() { return this.getAttribute("external") }
    get map() { return this.parentElement }

    set latitude(value) { return this.setAttribute("latitude", parseFloat(value)) }
    set longitude(value) { return this.setAttribute("longitude", parseFloat(value)) }

    constructor() {

        super();

    }

    hasInfoWindow() {

        return !!this.innerHTML.trim();

    }

    connectedCallback() {

        this.setAttribute("slot", '_' + Math.random().toString(36).substr(2, 9));

        if (this.map) {

            this.map.dispatchEvent(new CustomEvent("marker_added", { detail: this }));

        }

    }

    attributeChangedCallback(name, old, value) {

        if (!this.map || !this.map.update) return;

        this.map.update();

    }

});